import { useState } from "react";
import { Drawer, Button, Row, Col } from "antd";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
import TwizzImg from "../../assets/images/white-twizz.webp";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./index.less";

const HomePageNavbarComponent = () => {
  const { t } = useTranslation();
  const navItem = [
    { key: "become-fan", link: "/auth/signUp?currentTab=fan" },
    { key: "become-a-creator", link: "/auth/signUp?currentTab=creator" },
    { key: "contact-us", link: "/contact" },
  ];

  const btnItem = [
    { key: "home-nav-login-title", link: "/auth/signIn" },
    { key: "home-nav-register-title", link: "/auth/signUp" },
  ];

  const navItem2 = [...navItem, ...btnItem];

  const [drawerVisible, setDrawerVisible] = useState(false);

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
  };

  return (
    <div className="navbar_main">
      <div className="navbar-container">
        <Row className="navbar" align="middle">
          {/* Logo */}
          <Col className="logo-container">
            <Link to="/">
              <img src={TwizzImg} alt="Twizz" className="logo" />
            </Link>
          </Col>
          {/* Desktop Menu */}
          <Col className="desktop-menu">
            {navItem.map((item, index) => (
              <Link to={item?.link}>
                <Button type="text" className="nav-item" key={index}>
                  {t(item.key)}
                </Button>
              </Link>
            ))}
          </Col>
          {/* Desktop Buttons */}
          <Col className="desktop-buttons">
            {btnItem.map((item, index) => (
              <Link to={item?.link}>
                <Button key={index} type="default" shape="round" className={index === 0 ? "login-btn" : "register-btn"}>
                  {t(item.key)}
                </Button>
              </Link>
            ))}
          </Col>
          {/* Hamburger Menu for Mobile */}
          <Col className="mobile-menu-btn-container">
            <Button type="text" className="mobile-menu-btn" onClick={showDrawer}>
              <MenuOutlined className="menu-icon" />
            </Button>
          </Col>
        </Row>
        {/* Mobile Drawer */}
        <Drawer placement="right" open={drawerVisible} width="100%" className="mobile-drawer">
          <div className="mobile-menu-content">
            <div className="mobile-header">
              <img src={TwizzImg} alt="Twizz" className="mobile-logo" />
              closeIcon={<CloseOutlined className="close-icon" onClick={closeDrawer} />}
            </div>
            <div className="mobile-menu">
              {navItem2.map((item, index) => (
                <Link to={item?.link}>
                  <Button type="text" className="mobile-nav-item" key={index}>
                    {t(item.key)}
                  </Button>
                </Link>
              ))}
            </div>
          </div>
        </Drawer>
      </div>
    </div>
  );
};

export default HomePageNavbarComponent;
